/**
 * Aplicación web Directorio del Ayuntamiento de Zamora.
 * 
 * Desarrollo e implementación: Jaime León Pereira.
 * Ingeniero Informático de la Unidad TIC.
 */
import { useNavigate } from "react-router-dom";
import useVersionMovil from "../../hooks/useMobileVersion";
import "../../styles/AdminLayout.css";

/**
 * Componente de barra superior del panel de administración.
 * 
 * Proporciona navegación básica y controles de interfaz para el panel de administración,
 * incluyendo botones de menú (en versión móvil) y cierre de sesión.
 * Se adapta responsivamente a dispositivos móviles y de escritorio.
 */
const AdminTopbar = ({onMenuClick}) => {
  /* ============================
      Navegación y estado
     ============================ */
  
  // Hook de React Router para navegación programática
  const navigate = useNavigate();

  // Hook personalizado para detectar versión móvil
  const isMobile = useVersionMovil();

  /* ============================
     Manejo de eventos
     ============================ */

  /**
   * Maneja el cierre de sesión o retorno al inicio.
   * Navega a la página principal ("/") del directorio.
   */
  const handleLogout = () => {
    navigate("/");
  };
  
  /*************************************************************
   * Renderizado de la barra superior de administración        *
   *************************************************************/
  return (
    /* Barra de navegación superior */
    <nav className="admin-topbar navbar-expand-lg bg-white shadow px-4 py-3" 
      // Ajuste responsivo del margen izquierdo según versión móvil
      style={isMobile ? { left: "0px" } : { left: "240px" }}
    >
      {/* =============================
          Botón de menú (sólo en móvil)
          ============================= */}
      {isMobile &&(
        <button
          className="btn btn-outline-dark me-3"
          onClick={onMenuClick}
          aria-label="Abrir menú de navegación"
        >
          <i className="bi bi-list fs-3"></i>
        </button>
      )}
      {/* =============================
          Título y branding
          ============================= */}
      <div className="d-flex align-items-center">
        {/* Icono de configuración/administración */}
        <i className="bi bi-gear-fill text-primary fs-4 me-2"></i>
        {/* Título del panel de administración */}
        <span className="fw-bold fs-5 text-dark">Panel Administrador</span>
      </div>

      {/* =============================
          Controles de usuario
          ============================= */}
      <div className="ms-auto">
        {/* Botón para cerrar sesión/volver al inicio */}
        <button className="btn btn-outline-danger d-flex align-items-center gap-2" onClick={handleLogout}>
           {/* Icono de salida */}
          <i className="bi bi-box-arrow-right"></i> 
          {/* Texto del botón */}
          Atrás
        </button>
      </div>
    </nav>
  );
};

export default AdminTopbar;
